import React from "react";
import ContentPage from "../components/content-page";
import SEO from "../components/seo";
var PrivacyPage = function PrivacyPage(_ref) {
    var data = _ref.data;
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(SEO, {
        title: data.datoCmsPrivacy.title
    }), /*#__PURE__*/ React.createElement(ContentPage, {
        title: data.datoCmsPrivacy.title,
        content: data.datoCmsPrivacy.content
    }));
};
var query = "3341507965";
export default PrivacyPage;
